import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfileSvgComponent } from './profile-svg.component';

@NgModule({
  declarations: [
    ProfileSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    ProfileSvgComponent
  ]
})
export class ProfileSvgModule { }
